import React, { useState } from 'react'
import { IoCloseOutline } from "react-icons/io5";
import { CiLocationOn } from "react-icons/ci";
import { GoQuestion } from "react-icons/go";
import { RiTwitterXLine } from "react-icons/ri";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { contactAddresses } from '../data/contact';
import { motion } from 'framer-motion'





const Contact = ({setModal}) => {
    const [open, setOpen] = useState(false)


    const contact = [
        {
            id: 1,
            icon: <CiLocationOn className='text-base md:text-lg xl:text-2xl' />,
            desc: 'suleja Road, Bwari, P.M.B. 189, Garki, Abuja, Nigeria.',
        },
        {
            id: 2,
            icon: <GoQuestion className='text-sm md:text-base xl:text-xl' />,
            desc: 'support@jamb.gov.ng',
        },
        {
            id: 3,
            icon: <RiTwitterXLine className='text-xs md:text-sm xl:text-lg' />,
            desc: 'https://twitter.com/jambhq?lang=en',
        },
    ]


    const handleoffice = (item) => {
        setOpen((prevIndex) => prevIndex === item ? null : item )
      }

  return (
    <motion.div
     initial={{ scale: 0.5, opacity: 0 }}
     animate={{ scale: 1, opacity: [0.1, 0.1, 0.1, 0.3, 0.5, 0.7, 1] }}
     transition={{ duration: 0.7, ease: "easeIn" }}
     exit={{ opacity: 0, transition: { duration: 1.5, ease: "easeIn" } }}
     className='mb-10 w-full max-h-[95vh] z-50 bg-white pt-5 pb-7 shadow-md rounded-lg md:rounded-xl md:w-[95%] lg:-mt-16 lg:w-[90%] xl:rounded-2xl xl:pb-8 xl:-mt-24 xl:w-full
                max-w-screen-md mx-auto'>
          
        <div className='flex items-start justify-between w-full px-3 md:px-5 md:items-center lg:px-7'>
             <p className='text-[13px] text-[#101828] font-semibold w-[75%] md:text-[14px] lg:text-sm xl:text-base'>
                 Contact us
             </p>
             <IoCloseOutline onClick={()=>setModal(false)} className='text-xl lg:text-2xl xl:text-3xl' />
        </div>

        <div className='w-full mt-2.5 bg-[#DDE1E6] border-[1px] border-dashed lg:mt-3.5'></div>

        <div className='w-full overflow-y-auto max-h-[80vh] md:max-h-[78vh] lg:max-h-[77vh]'>
        {/* CONTACT INFO */}
        <div className='flex flex-col items-start w-full px-3 md:px-5 lg:px-7 mt-4 xl:mt-7'>
             <p className='text-[12px] text-[#101828] font-normal w-[75%] md:text-[13px] lg:text-sm xl:text-base'>
                 Contact Info
             </p>

             {contact.map((item) => {
              return(
             <div key={item.id} className='flex items-center w-full mt-2 md:mt-3 xl:mt-3.5'>
                   {item.icon}
                {item.id === 3    
                ?<a href='https://x.com' target="_blank" rel="noreferrer" 
                    className='text-[11px] text-[#25A249] font-normal w-[75%] ml-2 md:ml-3 md:text-[12px] lg:ml-2.5 lg:text-xs xl:text-[14px] xl:ml-3'>
                   {item.desc}
                </a>
                :item.id === 2 
                ?<a href='mailto:support@jamb.gov.ng' target="_blank" rel="noreferrer" 
                    className='text-[11px] text-[#101828] font-normal w-[75%] ml-2 md:ml-3 md:text-[12px] lg:ml-2.5 lg:text-xs xl:text-[14px] xl:ml-3'>
                   {item.desc}
                </a>
                :<p className='text-[11px] text-[#101828] font-normal w-[75%] ml-2 md:ml-3 md:text-[12px] lg:ml-2.5 lg:text-xs xl:text-[14px] xl:ml-3'>
                   {item.desc}
                </p>
                }
             </div>
             )
             })}
        </div>


        {/* JAMB OFFICES */}
        <div className='flex flex-col items-start w-full mt-5 md:mt-7 xl:mt-9'>
             <p className='text-[12px] text-[#101828] font-normal w-[75%] mb-1 px-3 md:px-5 md:text-[13px] lg:text-sm lg:px-7 xl:text-base xl:mb-0'>
                 JAMB Offices
             </p>

             {contactAddresses.map((item) => {
                return(
             <div key={item.id} 
             className={`flex flex-col items-center w-full pt-3 mt-[2px] px-3 md:px-5 md:pt-4 lg:px-7 xl:pt-6 ${item.id && 'hover:bg-[#eeeeee]'}`}>
                <div onClick={()=>handleoffice(item.id)} className={`flex items-center justify-between w-full ${open === item.id && 'mb-1.5 lg:mb-2'} `}>
                     <p className='text-[11px] text-[#101828] font-normal w-[75%] md:text-[12px] lg:text-[12px] xl:text-[14px]'>
                         {item.office}
                     </p>
                     {  
                       open === item.id
                       ?<IoIosArrowUp className='text-xs md:text-sm xl:text-lg' />
                       :<IoIosArrowDown className='text-xs md:text-sm xl:text-lg' />
                     }
                </div>

                {open === item.id &&
                <div className='w-full'>
                    {item.addresses?.map((item) => {
                        return(
                    <div key={item.id} className='flex flex-col items-start w-full mb-4'>
                         <p className={`text-[10px] text-[#101828] w-[90%] font-semibold mb-[2px] md:text-[11px] lg:text-[11px] xl:text-[13px]`}>
                            {item.text}
                            <span className={`font-normal pl-[2px] ${item.address ? 'text-[#101828]' : 'text-[#25A249]'}`}>
                                {item.address || item.phone}
                            </span>
                            
                            {item.link && 
                            <a href={item.href} target="_blank" rel="noreferrer"  className={`font-normal pl-1 text-[#25A249]`}>
                                {item.link}
                            </a>
                            }
                         </p>

                         {item.text3 &&
                         <p className={`text-[10px] text-[#101828] font-normal w-[90%] mb-[2px] md:text-[11px] lg:text-[11px] xl:text-[13px]`}>
                            {item.text3}
                            <a href={item.href3} target="_blank" rel="noreferrer"  className={`font-normal pl-1 text-[#25A249]`}>
                                {item.link3}
                            </a>
                         </p>}

                         {item.text3 &&
                         <p className={`text-[10px] text-[#101828] font-normal w-[90%] mb-[2px] md:text-[11px] lg:text-[11px] xl:text-[13px]`}>
                            {item.text4} 
                            <span className={`font-normal pl-1 text-[#25A249]`}>
                                {item.phone}
                            </span>
                         </p>}

                         <p className={`text-[10px] text-[#101828] font-normal w-[90%] md:text-[11px] lg:text-[11px] xl:text-[13px]`}>
                            {item.text2} 
                            <a href={item.href} target="_blank" rel="noreferrer"  className={`font-normal pl-1 text-[#25A249]`}>
                                {item.email}
                            </a>
                         </p>
                    </div>
                        )
                    })}
                </div>
                }
                

                {item.id !== 9 &&
                <hr className='bg-[#dddddd] w-full mt-1 xl:mt-1.5' />
                }
             </div>
                )
            })}
        </div>

        </div>


    </motion.div>
  )
}

export default Contact
